import { Navigate } from 'react-router';
import { useSession } from '@/auth';
import { landingRouteFor } from './roleRoutes';

/** '/' resolves to the role's own landing route. */
export function RoleLanding() {
  const session = useSession();
  return <Navigate to={landingRouteFor(session.role)} replace />;
}
